/**
 * Different steps for importing process
 */
export const ImportingSteps = {
    selectDataSource: 'selectDataSource',
    mapColumns: 'mapColumns',
    review: 'review',
    importing: 'importing'
}
/**
 * Different types of
 */
export const ImportingProcessStatus = {
    loading: 'loading',
    paused: 'paused',
    finished: 'finished',
}
/**
 * Different types of data supported by importing feature
 */
export const ImportingDataTypes = {
    partDescription: 'partDescription',
    partTitle: 'partTitle',
    partShortDescription: 'partShortDescription',
    partNotes: 'partNotes',
    partUPC: 'partUPC',
    partVisibility: 'partVisibility',
    partPriceLevels: 'partPriceLevels',
    partSerializability: 'partSerializability',
    partDeliveryMode: 'partDeliveryMode',
    partOnlineOrderEligibility: 'partOnlineOrderEligibility',
    productVisibilityToOtherPartners: 'productVisibilityToOtherPartners',
    partTechnicalInformation: 'partTechnicalInformation',
    productProperties: 'productProperties',
    customersTerritoriesAndAccountManagers: 'customersTerritoriesAndAccountManagers',
    warehouseAlertThresholds: 'warehouseAlertThresholds',
    productDimensions: 'productDimensions',
    productVendors: 'productVendors',
    priceMatrices: 'priceMatrices',
    externalCustomers: 'externalCustomers',
    externalVendors: 'externalVendors',
    externalProducts: 'externalProducts',
    productPropertyOptions: 'productPropertyOptions',
    productCategoryAssignment: 'productCategoryAssignment',
    productsFromAnotherPartner: 'productsFromAnotherPartner',
    productWarehouseAssignment: 'productWarehouseAssignment',
    setInventoryAvailability: 'setInventoryAvailability',
    productTagAssignment: 'productTagAssignment',
    productFormAssignment: 'productFormAssignment',
    productRelationAssignment: 'productRelationAssignment',
    productCodeAssignment: 'productCodeAssignment',
    removeProduct: 'removeProduct',
    productFlatShippingRates: 'productFlatShippingRates',
}